import React, { useEffect } from 'react';
import { CheckCircle, XCircle, AlertCircle, X } from 'lucide-react';
import { useNotificationStore } from '../store';

export const NotificationContainer: React.FC = () => {
  const { notifications, removeNotification } = useNotificationStore();

  // Auto-remove notifications after 5 seconds
  useEffect(() => {
    const timers = notifications.map((notification) => {
      return setTimeout(() => {
        removeNotification(notification.id);
      }, 5000);
    });

    return () => {
      timers.forEach((timer) => clearTimeout(timer));
    };
  }, [notifications, removeNotification]);

  if (notifications.length === 0) return null;

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2 pointer-events-none">
      {notifications.map((notification) => {
        const Icon = 
          notification.type === 'success' ? CheckCircle :
          notification.type === 'error' ? XCircle :
          AlertCircle;

        const bgColor =
          notification.type === 'success' ? 'bg-green-50/95 dark:bg-green-900/90 border-green-200 dark:border-green-800' :
          notification.type === 'error' ? 'bg-red-50/95 dark:bg-red-900/90 border-red-200 dark:border-red-800' :
          'bg-yellow-50/95 dark:bg-yellow-900/90 border-yellow-200 dark:border-yellow-800';

        const textColor =
          notification.type === 'success' ? 'text-green-800 dark:text-green-200' :
          notification.type === 'error' ? 'text-red-800 dark:text-red-200' :
          'text-yellow-800 dark:text-yellow-200';

        const iconColor =
          notification.type === 'success' ? 'text-green-600 dark:text-green-400' :
          notification.type === 'error' ? 'text-red-600 dark:text-red-400' :
          'text-yellow-600 dark:text-yellow-400';

        return (
          <div
            key={notification.id}
            className={`flex items-start gap-3 p-4 rounded-lg border shadow-lg pointer-events-auto backdrop-blur-sm ${bgColor} ${textColor} animate-slide-in-right max-w-md`}
          >
            <Icon className={`w-5 h-5 flex-shrink-0 mt-0.5 ${iconColor}`} />
            <p className="flex-1 text-sm font-medium break-words">{notification.message}</p>
            <button
              onClick={() => removeNotification(notification.id)}
              className={`flex-shrink-0 hover:opacity-70 transition-opacity ${iconColor}`}
              aria-label="Dismiss notification"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
};

